import React, { useState, useEffect, useRef, useCallback } from "react";
import morndul1 from "../assets/morndul1.png";
import morndul2 from "../assets/morndul2.png";
import morndul3 from "../assets/morndul3.png";
import morndul4 from "../assets/morndul4.png";
import { BsChevronCompactLeft, BsChevronCompactRight } from "react-icons/bs";
import { MdSquare } from "react-icons/md";

export const TextBasedRPG = () => {
  const slides = [
    { src: morndul1 },
    { src: morndul2 },
    { src: morndul3 },
    { src: morndul4 },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const slideIntervalRef = useRef(null);

  const prevSlide = useCallback(() => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  }, [currentIndex, slides.length]);

  const nextSlide = useCallback(() => {
    const isLastSlide = currentIndex === slides.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  }, [currentIndex, slides.length]);

  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };

  useEffect(() => {
    slideIntervalRef.current = setInterval(() => {
      nextSlide();
    }, 8000); // Change slide every 3 seconds

    return () => clearInterval(slideIntervalRef.current);
  }, [nextSlide]);

  useEffect(() => {
    clearInterval(slideIntervalRef.current);
    slideIntervalRef.current = setInterval(() => {
      nextSlide();
    }, 8000);

    return () => clearInterval(slideIntervalRef.current);
  }, [currentIndex, nextSlide]);

  return (
    <div
    name="textBased" 
      className="w-full  text-[#FCFFFC] bg-[#040F0F] pt-12"
    >
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full  pt-12">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 text-[#FCFFFC] border-[#248232] ">
            The Crypts of Morn'Dul
          </p>

          {/* body and img div */}
          <div className="flex flex-col md:flex-row md:items-center pb-4 pt-4 md:py-6 ">
            <div className="flex flex-col w-full md:w-1/2">
              <p className="pb-4">
                A text-based role-playing game built in C# and played in the
                console, featuring turn-based combat, character progression, and
                minimal ASCII art in homage to classic text adventure games. Players can
                explore, battle enemies, and grow stronger through an
                interactive story loop.
              </p>
              <p className="pb-4">
                As part of developing this, I have been working on emulating a console terminal in the browser using Blazor WebAssembly, replicating keyboard input, sequential text output, and menu navigation. A working demo of a small paint drying simulator console app is available below. Be warned, you may have as much fun as watching <strong>real</strong> paint dry...
              </p>

              <footer>
                <ul className="flex flex-wrap gap-2 mb-4">
                  <li className="bg-emerald-400 text-black text-xs font-bold px-3 py-1 rounded-full shadow-md">
                    In Development
                  </li>
                  <li className="bg-[#248232] text-[#FCFFFC] text-xs font-medium px-3 py-1 rounded-full">
                    C#
                  </li>
                </ul>
              </footer>
            </div>

            {/* image div */}
            <div className="md:max-w-[450px] lg:max-w-[550px] lg:h-[400px] md:h-[475px] h-[400px] w-full m-auto relative px-8 group pt-6  md:px-9 lg:pb-0 md:pb-12 ">
              <div
                style={{ backgroundImage: `url(${slides[currentIndex].src})` }}
                className="w-full h-full rounded-2xl bg-left bg-cover duration-500"
              ></div>
              {/* left arrow */}
              <div className="opacity-0 group-hover:opacity-100 translate-x-[-10px] group-hover:translate-x-0 transition-all duration-1000 absolute top-[50%] translate-y-[-50%] left-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer">
                <BsChevronCompactLeft onClick={prevSlide} size={30} />
              </div>
              {/* right arrow */}
              <div className="opacity-0 group-hover:opacity-100 translate-x-[10px] group-hover:translate-x-0 transition-all duration-1000 absolute top-[50%] translate-y-[-50%] right-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer">
                <BsChevronCompactRight onClick={nextSlide} size={30} />
              </div>
              <div className="flex top-4 justify-center py-2 ">
                {slides.map((slide, slideIndex) => (
                  <div
                    key={slideIndex}
                    onClick={() => goToSlide(slideIndex)}
                    className="text-2xl text-[#FCFFFC] cursor-pointer hover:text-[#2BA84A] hover:scale-125 duration-300 px-1"
                  >
                    <MdSquare />
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* buttons */}
          <div className="flex flex-row justify-center md:justify-start space-x-4 md:gap-6 lg:pt-8 md:pt-8 pt-12">
            <a
              href="https://paint-drying-sim.netlify.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="text-center mb-2 hover:bg-[#2BA84A] hover:border-[#2BA84A] duration-300 text-[#FCFFFC] group border-2 px-6 py-3 flex">
                Paint Drying Sim
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
